










































import { Component, Prop } from "vue-property-decorator";
import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";

import { VFlex } from "vuetify/lib";

import { required } from "vuelidate/lib/validators";
import { IInfluxDBConfiguration } from "sitewhere-configuration-model";

@Component({
  components: { DialogForm, FormText, VFlex },
  validations: {
    hostname: {
      required
    },
    port: {
      required
    },
    databaseName: {
      required
    }
  }
})
export default class InfluxDbFields extends DialogSection {
  @Prop() readonly readonly!: boolean;

  hostname: string | null = null;
  port: number | null = null;
  databaseName: string | null = null;

  /** Reset section content */
  reset(): void {
    this.hostname = null;
    this.port = null;
    this.databaseName = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(configuration: IInfluxDBConfiguration): void {
    this.hostname = configuration.hostname;
    this.port = configuration.port;
    this.databaseName = configuration.databaseName;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      hostname: this.hostname,
      port: this.port,
      databaseName: this.databaseName
    };
  }
}
